// import React, { useEffect, useState } from "react";
// import Swal from "sweetalert2";
// import { MdFilterListAlt, MdFilterAltOff } from "react-icons/md";
// import {
//   Table,
//   Spinner,
//   Button,
//   Pagination,
// } from "react-bootstrap";
// import { FaPlus } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";

// const API_URL = process.env.REACT_APP_API_URL;
// const imagesURL = `${process.env.REACT_APP_IMAGE_API_URL}/uploads/loanlead`;
// const LIMIT = 10;

// function Addaccount() {
//   const [users, setUsers] = useState([]);
//   const [allUsers, setAllUsers] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [loading, setLoading] = useState(true);

//   const [searchTerm, setSearchTerm] = useState({
//     status: "",
//     account_holder_name: "",
//     bank_name: "",
//     account_number: "",
//   });

//   const [showFilter, setShowFilter] = useState(false);
//   const toggleFilter = () => setShowFilter(!showFilter);

//   const navigate = useNavigate();

//   const getAuthToken = () => localStorage.getItem("token");

//   const fetchUsers = async (page = 1) => {
//     setLoading(true);
//     try {
//       const token = getAuthToken();
//       const url = `${API_URL}/bank-accounts-list?status=${searchTerm.status}&name=${searchTerm.account_holder_name}&bank=${searchTerm.bank_name}&account_number=${searchTerm.account_number}&page=${page}&limit=${LIMIT}`;

//       const response = await fetch(url, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       const result = await response.json();
//       const fetchedUsers = result.data || [];
//       setAllUsers(fetchedUsers);
//       setUsers(fetchedUsers);
//       setTotalPages(result.totalPages || 1);
//       setCurrentPage(page);
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchUsers(currentPage);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [currentPage]);

//   const handleSearch = (e) => {
//     if (e) e.preventDefault();
//     fetchUsers(1);
//   };

//   const toSentenceCase = (text) => {
//     if (!text) return "-";
//     return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "-";
//     const date = new Date(dateString);
//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = date.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const handleCreateClick = () => {
//     navigate("/create-account");
//   };

//   // ═══════════ INLINE STYLES ═══════════
//   const gradientBg =
//     "linear-gradient(135deg, #1e1b4b 0%, #3b0f6b 50%, #4c1d95 100%)";

//   const styles = {
//     filterToggle: {
//       display: "inline-flex",
//       alignItems: "center",
//       justifyContent: "center",
//       width: "42px",
//       height: "42px",
//       padding: 0,
//       border: showFilter
//         ? "1px solid #ffffff"
//         : "1px solid rgba(255, 255, 255, 0.3)",
//       background: showFilter ? "#ffffff" : "rgba(255, 255, 255, 0.15)",
//       color: showFilter ? "#1e1b4b" : "#ffffff",
//       borderRadius: "10px",
//       fontSize: "18px",
//       cursor: "pointer",
//       transition: "all 0.25s ease",
//       boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
//       backdropFilter: "blur(6px)",
//     },
//     addBtn: {
//       display: "inline-flex",
//       alignItems: "center",
//       gap: "8px",
//       height: "42px",
//       padding: "0 20px",
//       fontSize: "13.5px",
//       fontWeight: 700,
//       color: "#fff",
//       background: gradientBg,
//       border: "none",
//       borderRadius: "10px",
//       cursor: "pointer",
//       whiteSpace: "nowrap",
//       boxShadow: "0 4px 14px rgba(76, 29, 149, 0.35)",
//       transition: "all 0.22s ease",
//     },
//     filterSelect: {
//       flex: "1 1 0",
//       minWidth: 0,
//       height: "44px",
//       padding: "0 40px 0 16px",
//       fontSize: "13.5px",
//       border: "1.5px solid #e2e8f0",
//       borderRadius: "10px",
//       background: "#fff",
//       color: "#0f172a",
//       outline: "none",
//       boxSizing: "border-box",
//       margin: 0,
//       cursor: "pointer",
//       appearance: "none",
//       backgroundImage:
//         "url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%2364748b%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpolyline%20points%3D%226%209%2012%2015%2018%209%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E\")",
//       backgroundRepeat: "no-repeat",
//       backgroundPosition: "right 14px center",
//       backgroundSize: "14px",
//     },
//     searchBtn: {
//       flexShrink: 0,
//       height: "44px",
//       padding: "0 28px",
//       fontSize: "13.5px",
//       fontWeight: 700,
//       color: "#fff",
//       background: gradientBg,
//       border: "none",
//       borderRadius: "10px",
//       cursor: "pointer",
//       whiteSpace: "nowrap",
//       boxShadow: "0 4px 14px rgba(76, 29, 149, 0.35)",
//       transition: "all 0.22s ease",
//       margin: 0,
//     },
//   };

//   return (
//     <div className="padding_15">
//       <div className="card">
//         <div className="card-header">
//           <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
//             <div className="titlepage">
//               <h3 className="mb-0">Accounts Lists</h3>
//             </div>

//             <div className="d-flex align-items-center gap-2">
//               {/* Filter Toggle Icon — mobile + desktop */}
//               <button
//                 type="button"
//                 onClick={toggleFilter}
//                 title={showFilter ? "Hide Filters" : "Show Filters"}
//                 style={styles.filterToggle}
//                 onMouseEnter={(e) => {
//                   if (!showFilter) {
//                     e.currentTarget.style.background =
//                       "rgba(255, 255, 255, 0.25)";
//                     e.currentTarget.style.transform = "translateY(-2px)";
//                   }
//                 }}
//                 onMouseLeave={(e) => {
//                   if (!showFilter) {
//                     e.currentTarget.style.background =
//                       "rgba(255, 255, 255, 0.15)";
//                     e.currentTarget.style.transform = "translateY(0)";
//                   }
//                 }}
//               >
//                 {showFilter ? <MdFilterAltOff /> : <MdFilterListAlt />}
//               </button>

//               {/* Add Account Button */}
//               <button
//                 onClick={handleCreateClick}
//                 style={styles.addBtn}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = "translateY(-2px)";
//                   e.currentTarget.style.boxShadow =
//                     "0 8px 20px rgba(76, 29, 149, 0.5)";
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = "translateY(0)";
//                   e.currentTarget.style.boxShadow =
//                     "0 4px 14px rgba(76, 29, 149, 0.35)";
//                 }}
//               >
//                 <FaPlus />
//                 Add Account
//               </button>
//             </div>
//           </div>

//           {/* ═══════════ FILTER SECTION (toggled) ═══════════ */}
//           {showFilter && (
//             <form
//               onSubmit={handleSearch}
//               style={{
//                 display: "flex",
//                 flexWrap: "wrap",
//                 gap: "12px",
//                 alignItems: "center",
//                 marginTop: "16px",
//                 width: "100%",
//               }}
//             >
//               <select
//                 name="status"
//                 value={searchTerm.status}
//                 onChange={(e) =>
//                   setSearchTerm({
//                     ...searchTerm,
//                     [e.target.name]: e.target.value,
//                   })
//                 }
//                 style={styles.filterSelect}
//                 onFocus={(e) => {
//                   e.currentTarget.style.borderColor = "#6366f1";
//                   e.currentTarget.style.boxShadow =
//                     "0 0 0 4px rgba(99, 102, 241, 0.12)";
//                 }}
//                 onBlur={(e) => {
//                   e.currentTarget.style.borderColor = "#e2e8f0";
//                   e.currentTarget.style.boxShadow = "none";
//                 }}
//               >
//                 <option value="">All Status</option>
//                 <option value="pending">Pending</option>
//                 <option value="success">Success</option>
//                 <option value="reject">Reject</option>
//               </select>

//               <button
//                 type="submit"
//                 style={styles.searchBtn}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = "translateY(-2px)";
//                   e.currentTarget.style.boxShadow =
//                     "0 8px 20px rgba(76, 29, 149, 0.5)";
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = "translateY(0)";
//                   e.currentTarget.style.boxShadow =
//                     "0 4px 14px rgba(76, 29, 149, 0.35)";
//                 }}
//               >
//                 Search
//               </button>
//             </form>
//           )}
//         </div>

//         <div className="card-body">
//           {loading ? (
//             <div className="text-center py-5">
//               <Spinner animation="border" />
//               <p className="mt-3">Loading accounts...</p>
//             </div>
//           ) : (
//             <>
//               <div className="table-responsive">
//                 <Table bordered>
//                   <thead className="table-dark">
//                     <tr>
//                       <th>#</th>
//                       <th>Account Holder Name</th>
//                       <th>Bank Name</th>
//                       <th>Branch Name</th>
//                       <th>Account Number</th>
//                       <th>IFSC Code</th>
//                       <th>PassBook / Cheque</th>
//                       <th>Status</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {users.length === 0 ? (
//                       <tr>
//                         <td
//                           colSpan="8"
//                           className="text-center text-danger fw-bold"
//                         >
//                           No data found!
//                         </td>
//                       </tr>
//                     ) : (
//                       users.map((user, index) => (
//                         <tr key={user.id}>
//                           <td>{(currentPage - 1) * LIMIT + index + 1}</td>
//                           <td>{toSentenceCase(user.account_holder_name)}</td>
//                           <td>{toSentenceCase(user.bank_name)}</td>
//                           <td>{toSentenceCase(user.bank_branch_name)}</td>
//                           <td>{toSentenceCase(user.account_number)}</td>
//                           <td>{user.ifsc_code?.toUpperCase()}</td>
//                           <td>
//                             <div className="d-flex">
//                               {user.image &&
//                                 user.image
//                                   .split(",")
//                                   .map((imgName, idx) => {
//                                     const trimmedImg = imgName
//                                       .trim()
//                                       .toLowerCase();
//                                     const isPDF =
//                                       trimmedImg.endsWith(".pdf");

//                                     return (
//                                       <div
//                                         className="position-relative"
//                                         key={idx}
//                                       >
//                                         <div className="position-relative listaccountdesign">
//                                           {isPDF ? (
//                                             <div
//                                               className="pdf-placeholder d-flex align-items-center justify-content-center bg-secondary text-white"
//                                               style={{
//                                                 width: "100%",
//                                                 height: "100%",
//                                                 fontSize: "14px",
//                                               }}
//                                             >
//                                               PDF
//                                             </div>
//                                           ) : (
//                                             <img
//                                               src={`${imagesURL}/${trimmedImg}`}
//                                               alt={trimmedImg}
//                                               className="img-thumbnail"
//                                               style={{
//                                                 width: "100%",
//                                                 height: "100%",
//                                                 objectFit: "cover",
//                                               }}
//                                             />
//                                           )}
//                                           <small className="d-block text-truncate-custum">
//                                             {imgName}
//                                           </small>
//                                         </div>
//                                         <a
//                                           href={`${imagesURL}/${trimmedImg}`}
//                                           download
//                                           target="_blank"
//                                           rel="noopener noreferrer"
//                                           className="btn btn-sm btn-primary position-absolute"
//                                           style={{
//                                             top: 0,
//                                             right: 0,
//                                             borderRadius: "50%",
//                                             padding: "0 5px",
//                                           }}
//                                         >
//                                           ⬇
//                                         </a>
//                                       </div>
//                                     );
//                                   })}
//                             </div>
//                           </td>
//                           <td>
//                             {user.status === "pending" ? (
//                               <span className="badge bg-warning text-white">
//                                 Pending
//                               </span>
//                             ) : user.status === "success" ? (
//                               <span className="badge bg-success">
//                                 Success
//                               </span>
//                             ) : user.status === "reject" ? (
//                               <span className="badge bg-danger">
//                                 Rejected
//                               </span>
//                             ) : (
//                               toSentenceCase(user.status)
//                             )}
//                           </td>
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                 </Table>
//               </div>

//               {users.length > 0 && (
//                 <div className="d-flex justify-content-end">
//                   <Pagination>
//                     <Pagination.Prev
//                       onClick={() => handlePageChange(currentPage - 1)}
//                       disabled={currentPage === 1}
//                     />
//                     <Pagination.Item
//                       active={1 === currentPage}
//                       onClick={() => handlePageChange(1)}
//                     >
//                       1
//                     </Pagination.Item>

//                     {currentPage > 3 && <Pagination.Ellipsis />}
//                     {currentPage > 2 && (
//                       <Pagination.Item
//                         onClick={() => handlePageChange(currentPage - 1)}
//                       >
//                         {currentPage - 1}
//                       </Pagination.Item>
//                     )}
//                     {currentPage !== 1 && currentPage !== totalPages && (
//                       <Pagination.Item active>{currentPage}</Pagination.Item>
//                     )}
//                     {currentPage < totalPages - 1 && (
//                       <Pagination.Item
//                         onClick={() => handlePageChange(currentPage + 1)}
//                       >
//                         {currentPage + 1}
//                       </Pagination.Item>
//                     )}
//                     {currentPage < totalPages - 2 && <Pagination.Ellipsis />}
//                     {totalPages > 1 && (
//                       <Pagination.Item
//                         active={totalPages === currentPage}
//                         onClick={() => handlePageChange(totalPages)}
//                       >
//                         {totalPages}
//                       </Pagination.Item>
//                     )}
//                     <Pagination.Next
//                       onClick={() => handlePageChange(currentPage + 1)}
//                       disabled={currentPage === totalPages}
//                     />
//                   </Pagination>
//                 </div>
//               )}
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Addaccount;
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { MdFilterListAlt, MdFilterAltOff } from "react-icons/md";
import {
  Table,
  Spinner,
  Button,
  Pagination,
} from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;
const imagesURL = `${process.env.REACT_APP_IMAGE_API_URL}/uploads/loanlead`;
const LIMIT = 10;

function Addaccount() {
  const [users, setUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);

  const [searchTerm, setSearchTerm] = useState({
    status: "",
    account_holder_name: "",
    bank_name: "",
    account_number: "",
  });

  const [showFilter, setShowFilter] = useState(false);
  const toggleFilter = () => setShowFilter(!showFilter);

  const navigate = useNavigate();

  const getAuthToken = () => localStorage.getItem("token");

  const fetchUsers = async (page = 1) => {
    setLoading(true);
    try {
      const token = getAuthToken();
      const url = `${API_URL}/bank-accounts-list?status=${searchTerm.status}&name=${searchTerm.account_holder_name}&bank=${searchTerm.bank_name}&account_number=${searchTerm.account_number}&page=${page}&limit=${LIMIT}`;

      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await response.json();
      const fetchedUsers = result.data || [];
      setAllUsers(fetchedUsers);
      setUsers(fetchedUsers);
      setTotalPages(result.totalPages || 1);
      setCurrentPage(page);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const handleSearch = (e) => {
    if (e) e.preventDefault();
    fetchUsers(1);
  };

  const toSentenceCase = (text) => {
    if (!text) return "-";
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleCreateClick = () => {
    navigate("/create-account");
  };

  // ═══════════ INLINE STYLES ═══════════
  const gradientBg =
    "linear-gradient(135deg, #1e1b4b 0%, #3b0f6b 50%, #4c1d95 100%)";

  const styles = {
    filterToggle: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: "42px",
      height: "42px",
      padding: 0,
      border: showFilter
        ? "1px solid #ffffff"
        : "1px solid rgba(255, 255, 255, 0.3)",
      background: showFilter ? "#ffffff" : "rgba(255, 255, 255, 0.15)",
      color: showFilter ? "#1e1b4b" : "#ffffff",
      borderRadius: "10px",
      fontSize: "18px",
      cursor: "pointer",
      transition: "all 0.25s ease",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      backdropFilter: "blur(6px)",
    },
    addBtn: {
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      height: "42px",
      padding: "0 20px",
      fontSize: "13.5px",
      fontWeight: 700,
      color: "#fff",
      background: gradientBg,
      border: "none",
      borderRadius: "10px",
      cursor: "pointer",
      whiteSpace: "nowrap",
      boxShadow: "0 4px 14px rgba(76, 29, 149, 0.35)",
      transition: "all 0.22s ease",
    },
    filterSelect: {
      flex: "1 1 0",
      minWidth: 0,
      height: "44px",
      padding: "0 40px 0 16px",
      fontSize: "13.5px",
      border: "1.5px solid #e2e8f0",
      borderRadius: "10px",
      background: "#fff",
      color: "#0f172a",
      outline: "none",
      boxSizing: "border-box",
      margin: 0,
      cursor: "pointer",
      appearance: "none",
      backgroundImage:
        "url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%2364748b%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpolyline%20points%3D%226%209%2012%2015%2018%209%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E\")",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 14px center",
      backgroundSize: "14px",
    },
    searchBtn: {
      flexShrink: 0,
      height: "44px",
      padding: "0 28px",
      fontSize: "13.5px",
      fontWeight: 700,
      color: "#fff",
      background: gradientBg,
      border: "none",
      borderRadius: "10px",
      cursor: "pointer",
      whiteSpace: "nowrap",
      boxShadow: "0 4px 14px rgba(76, 29, 149, 0.35)",
      transition: "all 0.22s ease",
      margin: 0,
    },
  };

  // ═══════════ FILE PREVIEW RENDERER ═══════════
  const renderFilePreview = (imgName) => {
    const trimmedImg = imgName.trim().toLowerCase();
    const isPDF = trimmedImg.endsWith(".pdf");
    const fileUrl = `${imagesURL}/${trimmedImg}`;

    return (
      <div
        key={trimmedImg}
        style={{
          position: "relative",
          width: "70px",
          height: "70px",
          flexShrink: 0,
        }}
      >
        {/* Preview Box */}
        <a
          href={fileUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "block",
            width: "100%",
            height: "100%",
            borderRadius: "8px",
            overflow: "hidden",
            border: "1px solid #e2e8f0",
            background: "#f8fafc",
            textDecoration: "none",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
            e.currentTarget.style.transform = "translateY(-2px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = "none";
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          {isPDF ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%",
                background: "#fee2e2",
                color: "#dc2626",
                fontWeight: 700,
                fontSize: "12px",
                letterSpacing: "0.5px",
              }}
            >
              <span
                style={{
                  fontSize: "20px",
                  lineHeight: 1,
                  marginBottom: "4px",
                }}
              >
                📄
              </span>
              PDF
            </div>
          ) : (
            <img
              src={fileUrl}
              alt={trimmedImg}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              onError={(e) => {
                e.currentTarget.src =
                  "https://placehold.co/70x70/e2e8f0/64748b?text=N/A";
              }}
            />
          )}
        </a>

        {/* Download Button — top right */}
        <a
          href={fileUrl}
          download
          target="_blank"
          rel="noopener noreferrer"
          style={{
            position: "absolute",
            top: "-6px",
            right: "-6px",
            width: "22px",
            height: "22px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: gradientBg,
            color: "#fff",
            borderRadius: "50%",
            fontSize: "11px",
            textDecoration: "none",
            boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
            border: "2px solid #fff",
            transition: "all 0.2s ease",
          }}
          title="Download"
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.15)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          ⬇
        </a>
      </div>
    );
  };

  return (
    <div className="padding_15">
      <div className="card">
        <div className="card-header">
          <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
            <div className="titlepage">
              <h3 className="mb-0">Accounts Lists</h3>
            </div>

            <div className="d-flex align-items-center gap-2">
              {/* Filter Toggle Icon */}
              <button
                type="button"
                onClick={toggleFilter}
                title={showFilter ? "Hide Filters" : "Show Filters"}
                style={styles.filterToggle}
                onMouseEnter={(e) => {
                  if (!showFilter) {
                    e.currentTarget.style.background =
                      "rgba(255, 255, 255, 0.25)";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!showFilter) {
                    e.currentTarget.style.background =
                      "rgba(255, 255, 255, 0.15)";
                    e.currentTarget.style.transform = "translateY(0)";
                  }
                }}
              >
                {showFilter ? <MdFilterAltOff /> : <MdFilterListAlt />}
              </button>

              {/* Add Account Button */}
              <button
                onClick={handleCreateClick}
                style={styles.addBtn}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 20px rgba(76, 29, 149, 0.5)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 14px rgba(76, 29, 149, 0.35)";
                }}
              >
                <FaPlus />
                Add Account
              </button>
            </div>
          </div>

          {/* ═══════════ FILTER SECTION ═══════════ */}
          {showFilter && (
            <form
              onSubmit={handleSearch}
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "12px",
                alignItems: "center",
                marginTop: "16px",
                width: "100%",
              }}
            >
              <select
                name="status"
                value={searchTerm.status}
                onChange={(e) =>
                  setSearchTerm({
                    ...searchTerm,
                    [e.target.name]: e.target.value,
                  })
                }
                style={styles.filterSelect}
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = "#6366f1";
                  e.currentTarget.style.boxShadow =
                    "0 0 0 4px rgba(99, 102, 241, 0.12)";
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = "#e2e8f0";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <option value="">All Status</option>
                <option value="pending">Pending</option>
                <option value="success">Success</option>
                <option value="reject">Reject</option>
              </select>

              <button
                type="submit"
                style={styles.searchBtn}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 20px rgba(76, 29, 149, 0.5)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 14px rgba(76, 29, 149, 0.35)";
                }}
              >
                Search
              </button>
            </form>
          )}
        </div>

        <div className="card-body">
          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" />
              <p className="mt-3">Loading accounts...</p>
            </div>
          ) : (
            <>
              <div className="table-responsive">
                <Table bordered>
                  <thead className="table-dark">
                    <tr>
                      <th>#</th>
                      <th>Account Holder Name</th>
                      <th>Bank Name</th>
                      <th>Branch Name</th>
                      <th>Account Number</th>
                      <th>IFSC Code</th>
                      <th>PassBook / Cheque</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.length === 0 ? (
                      <tr>
                        <td
                          colSpan="8"
                          className="text-center text-danger fw-bold"
                        >
                          No data found!
                        </td>
                      </tr>
                    ) : (
                      users.map((user, index) => (
                        <tr key={user.id}>
                          <td>{(currentPage - 1) * LIMIT + index + 1}</td>
                          <td>{toSentenceCase(user.account_holder_name)}</td>
                          <td>{toSentenceCase(user.bank_name)}</td>
                          <td>{toSentenceCase(user.bank_branch_name)}</td>
                          <td>{toSentenceCase(user.account_number)}</td>
                          <td>{user.ifsc_code?.toUpperCase()}</td>
                          <td>
                            {/* ✅ File previews */}
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                flexWrap: "wrap",
                                alignItems: "flex-start",
                              }}
                            >
                              {user.image &&
                                user.image
                                  .split(",")
                                  .map((imgName) =>
                                    renderFilePreview(imgName)
                                  )}
                            </div>
                          </td>
                          <td>
                            {user.status === "pending" ? (
                              <span className="badge bg-warning text-white">
                                Pending
                              </span>
                            ) : user.status === "success" ? (
                              <span className="badge bg-success">
                                Success
                              </span>
                            ) : user.status === "reject" ? (
                              <span className="badge bg-danger">
                                Rejected
                              </span>
                            ) : (
                              toSentenceCase(user.status)
                            )}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>

              {users.length > 0 && (
                <div className="d-flex justify-content-end">
                  <Pagination>
                    <Pagination.Prev
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    />
                    <Pagination.Item
                      active={1 === currentPage}
                      onClick={() => handlePageChange(1)}
                    >
                      1
                    </Pagination.Item>

                    {currentPage > 3 && <Pagination.Ellipsis />}
                    {currentPage > 2 && (
                      <Pagination.Item
                        onClick={() => handlePageChange(currentPage - 1)}
                      >
                        {currentPage - 1}
                      </Pagination.Item>
                    )}
                    {currentPage !== 1 && currentPage !== totalPages && (
                      <Pagination.Item active>{currentPage}</Pagination.Item>
                    )}
                    {currentPage < totalPages - 1 && (
                      <Pagination.Item
                        onClick={() => handlePageChange(currentPage + 1)}
                      >
                        {currentPage + 1}
                      </Pagination.Item>
                    )}
                    {currentPage < totalPages - 2 && <Pagination.Ellipsis />}
                    {totalPages > 1 && (
                      <Pagination.Item
                        active={totalPages === currentPage}
                        onClick={() => handlePageChange(totalPages)}
                      >
                        {totalPages}
                      </Pagination.Item>
                    )}
                    <Pagination.Next
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    />
                  </Pagination>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Addaccount;